import React from "react";
import { useParams } from "react-router-dom";
import Style from "../../style/eventfilterright.module.scss";

const EventFilterRight = ({ itemList, filteredData }: any) => {
  const { type, city, category, designation } = useParams();

  const toSlug = (str: string) =>
    str.toLowerCase().replace(/ & /g, "-&-").replace(/\s+/g, "-");

  const filteredIds = new Set(filteredData.map((item: any) => item.id));

  const relatedEvents = itemList.filter((item: any) => {
    if (filteredIds.has(item.id)) return false;

    const matchesType = type
      ? item.tags?.some((tag: string) => toSlug(tag) === toSlug(type))
      : false;

    const matchesCategory = category
      ? item.categories?.some((cat: string) => toSlug(cat) === toSlug(category))
      : false;

    const matchesDesignation = designation
      ? toSlug(item.organiser.contact.designation) === toSlug(designation)
      : false;

    const matchesCity = city ? toSlug(item.venue.city) === toSlug(city) : false;

    return matchesType || matchesCategory || matchesDesignation || matchesCity;
  });

  const bgColors = ["#f8f9fa", "#f1f5f9", "#eef6ec", "#fef5e7", "#f0ebf8"];

  return (
    <div className={Style.container}>
      <div className={Style.banner}>
        <h3>🔥 Trending This Week</h3>
        <p>Explore upcoming sessions you might love based on your interest.</p>
        <a href="/all-event" className={Style.exploreBtn}>
          Explore All Events
        </a>
      </div>
      <h3 className={Style.heading}>Related Events</h3>
      {relatedEvents.length === 0 ? (
        <p>No related events found.</p>
      ) : (
        relatedEvents.slice(0, 20).map((event: any, index: number) => (
          <div
            key={event.id}
            className={Style.card}
            style={{ backgroundColor: bgColors[index % bgColors.length] }}
          >
            <h4>{event.venue.name}</h4>
            <p>{event.venue.city}</p>
            <p>
              {event.start_date} - {event.end_date}
            </p>
            <small>{event.categories.join(", ")}</small>
          </div>
        ))
      )}
    </div>
  );
};

export default EventFilterRight;
